export const acciones_sail = [
{
        "anio" : "Solicitar inscripción SAIL",
        "descripcion" : "Mecanismo que ayuda a los centros de trabajo",
        "trimestres" : [
            {
                "trimestre" : ".",
                "url" : "http://justicialaboral.hidalgo.gob.mx/st/dgtyps/revision/"
            }
        ]
    },{
        "anio" : "Acceso a usuarios",
        "descripcion" : "Acceso a usarios registrados en sistema",
        "trimestres" : [
            {
                "trimestre" : ".",
                "url" : "http://justicialaboral.hidalgo.gob.mx/st/dgtyps/inicio/"
            }
        ]
    }
]